import { Flex, Text } from "@/atoms"
import { Code } from "@/molecules/Code"
import { getThreatDetectionCredential } from "@/pages/DeploymentsPage/application/useAgentPlatform.selector"
import { AppRegistrationValue } from "./AppRegistrationValue"
import { useAppRegistrationTranslation } from "./useAppRegistrationTranslation"

import type { ThreatDetectionCredentialProps } from "./AppRegistrationSteps.types"

// The second federated credential: Copilot Studio's threat detection signs in
// as the app with it. It names the tenant, so it shows once its id is known
export const ThreatDetectionCredential = ({
  preInstall,
  azureTenantId
}: ThreatDetectionCredentialProps) => {
  const t = useAppRegistrationTranslation()
  const credential = getThreatDetectionCredential(
    azureTenantId,
    preInstall.threatDetectionUrl
  )

  return (
    <Flex vertical gap={8}>
      <Text strong>{t("threatDetectionCredentialTitle")}</Text>
      <Text>{t("threatDetectionCredential")}</Text>
      {credential ? (
        <Code.CommandCard>
          <AppRegistrationValue label={t("issuer")} value={credential.issuer} />
          <AppRegistrationValue
            label={t("subject")}
            value={credential.subject}
          />
          <AppRegistrationValue
            label={t("audience")}
            value={credential.audience}
          />
        </Code.CommandCard>
      ) : (
        <Text type="secondary">{t("threatDetectionCredentialTenant")}</Text>
      )}
    </Flex>
  )
}
